<template>
    <v-app id="main" :dark="dark" :light="!dark">
        <v-content>
            <v-container fluid grid-list-xl class="py-5 image-bg5 image-bg">
                <vorsi-toolbar></vorsi-toolbar>
                <v-layout column class="text-xs-center">
                    <div>
                        <div class="display-1 pt-5">
                            <b>How Does Vorsi Work?</b>
                        </div>
                        <div class="headline pt-2 pb-3">
                            Frequently Asked Questions
                        </div>
                    </div>
                </v-layout>
            </v-container>
            <v-container fluid grid-list-xl class="py-5" style="max-width: 1200px;">
                <v-layout row wrap justify-center>
                    <v-flex xs12 sm6>
                        <v-expansion-panel
                            v-model="panel"
                            expand
                        >
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        How much time is usually required for the implementation of Vorsi software in a
                                        business?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        On average, the implementation process for Vorsi software takes between 6 weeks
                                        to 3 months. The
                                        exact duration hinges on the allocation of resources and time to the project.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        To what extent can Vorsi be customized?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Vorsi offers full customization capabilities. Our team of skilled programmers
                                        can transform intricate tasks into a cohesive software solution tailored to your
                                        specific needs.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        What types of businesses is Vorsi tailored for?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Vorsi is crafted and able to be customized to suit both emerging startups and
                                        medium-sized enterprises. Our array of plans caters to various scales, enabling
                                        businesses to initiate their journey at a manageable level and scale up
                                        functionalities as their operations expand.

                                        Our clientele spans from small local retailers to enterprises achieving annual
                                        revenues exceeding $25 million. Presently, we have customers effectively
                                        managing more than 20 concurrent users and thousands of clients within the
                                        bakery system. Our offerings encompass diverse features such as purchase
                                        ordering, order and inventory management, production tracking, and an array of
                                        other functionalities.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        Is it possible for any of my team members to reach out to Vorsi for assistance?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        We extend support to all staff members to maintain the continuity of your
                                        business operations. In cases where there is a requirement for sensitive
                                        information, we will initiate communication with the main contact or owner of
                                        the bakery or business to discuss the request before proceeding with the
                                        necessary support.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        What is the pricing for Vorsi?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Vorsi's cost is determined by its modular structure, the selected modules, as
                                        well as the number of concurrent users and clients needed. Our offering includes
                                        a Cloud-based implementation, with a straightforward monthly rental starting at
                                        $250 per month. This fee covers software usage, support, and updates. <br><br>

                                        For a personalized pricing quote, please reach out to our sales representative
                                        at
                                        <a href='mailto:support@vorsi.io'
                                           style="text-decoration: none; cursor: pointer; color: white; font-weight: bold">
                                            Support@Vorsi.io.
                                        </a>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        Can I access Vorsi on a mobile device such as a tablet or smartphone?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Yes, Vorsi is designed to provide seamless accessibility on various mobile
                                        devices, including tablets and smartphones. This ensures that you can
                                        conveniently manage and monitor your bakery operations while on the go,
                                        enhancing flexibility and convenience in your workflow.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        Is emergency software support available beyond the standard support hours?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Yes, Vorsi provides round-the-clock support, ensuring assistance is accessible
                                        at any time, even outside of regular support hours.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-expansion-panel
                            v-model="panel2"
                            expand
                        >
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        What differentiates Vorsi from other software in the ERP industry?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Vorsi distinguishes itself from other software within the ERP industry primarily
                                        through its exceptional customization capabilities, affording businesses the
                                        ability to tailor the software to their precise needs. This adaptability ensures
                                        a seamless integration with distinct processes, positioning Vorsi as an
                                        exceptionally versatile solution. <br><br>
                                        Additionally, its specialized concentration on
                                        the food manufacturing and distribution sectors equips it with industry-specific
                                        expertise, showcased in features such as comprehensive production management and
                                        adept accounts receivable functionalities.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        Which accounting software is compatible with Vorsi bakery software?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Unlike other solutions, Vorsi incorporates built-in accounting software,
                                        eliminating the need for external integration. <br><br>
                                        Vorsi effortlessly exports data facilitating seamless synchronization
                                        through simple .csv exports.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        Is it possible to edit existing reports or create new ones independently within
                                        Vorsi?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Absolutely, Vorsi offers complete customization of reports. Report
                                        configurations can be saved as micro presets, which can then be organized into a
                                        macro preset, streamlining the generation of multiple micro presets with a
                                        single command. <br><br>
                                        Furthermore, the Vorsi development team is capable of crafting any report type
                                        you require, ensuring tailored reporting solutions that meet your specific
                                        needs.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        Is Vorsi capable of managing business phone calls and SMS?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Vorsi seamlessly integrates with Twilio, enabling your business phone operations
                                        to function within the cloud-based software. Moreover, Vorsi offers
                                        compatibility with hardware devices like office phones and PA systems.
                                        Additionally, the software boasts full SMS capabilities, further enhancing its
                                        communication features.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        What type of database does Vorsi utilize?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Vorsi employs MySQL for permanent data storage purposes and Redis for session
                                        caching and as a search engine.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        Does Vorsi offer automatic database backups?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Indeed, Vorsi features an automated database backup mechanism for its
                                        cloud-based system. These backups are stored on AWS S3, occurring multiple times
                                        throughout the day to ensure data security and redundancy.
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content class="mt-3">
                                <template v-slot:header>
                                    <div class="subheading font-weight-bold">
                                        How can my staff contact Vorsi support?
                                    </div>
                                </template>
                                <v-card>
                                    <v-card-text class="body-1">
                                        Email: <a href='mailto:support@vorsi.io'
                                                  style="text-decoration: none; cursor: pointer; color: white; font-weight: bold">
                                        Support@Vorsi.io
                                    </a> <br>
                                        Phone: <a href='tel:+19178469154'
                                                  style="text-decoration: none; cursor: pointer; color: white; font-weight: bold">
                                        (917) 846 9154
                                    </a> <br>
                                        Online Support Though Dashboard <br>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <vorsi-footer></vorsi-footer>
    </v-app>
</template>

<script>

export default {
    data: () => ({
        loading: false,
        disabled: false,
        showAlert: false,
        alertType: 'success',
        alertMessage: '',
        dark: true,
        panel: [false, false, false, false, false, false, false],
        panel2: [false, false, false, false, false, false, false],
    }),
    methods: {
        goTo(route) {
            window.location = route;
        },
    },
};
</script>

<style scoped>

</style>
